<template>
  <v-container fluid class="purchase-create-page pa-0">
    <v-card outlined class="purchase-create-card">
      <div class="purchase-create-header">
        <div class="title-wrap">
          <v-btn icon small class="mr-2" @click="cancel">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div>
            <div class="page-title">Create Purchase</div>
          </div>
        </div>

        <div class="header-actions">
          <v-btn
            v-if="!$vuetify.breakpoint.xsOnly"
            small
            rounded
            text
            @click.stop.prevent="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            rounded
            depressed
            dark
            :loading="loading"
            :disabled="PurchaseDetails.length === 0"
            @click="savePurchase"
          >
            <v-icon left small>mdi-content-save-outline</v-icon>
            Save {{ purchaseTotal | currency }}
          </v-btn>
        </div>
      </div>

      <v-card-text class="pa-3">
        <v-row dense>
          <v-col cols="12" md="5">
            <div class="field-label">Vendor</div>
            <AutoComplete v-model="selectedVendor" :initValue="initVendor" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="field-label">Purchase Date</div>
            <DateSelector v-model="purchaseDate" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="field-label">Reference Number</div>
            <v-text-field label="Reference Number" outlined dense hide-details v-model="purchaseRefNumber" />
          </v-col>
          <v-col cols="12" md="1" class="note-column">
            <v-btn block outlined color="primary" height="40" @click="noteDialog = true">
              <v-icon :left="$vuetify.breakpoint.mdAndDown" small>mdi-note-text-outline</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndDown">Note</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="purchase-create-content">
      <div>
        <v-alert
          v-if="inboundDelivery"
          type="info"
          text
          dense
          class="mb-0"
        >
          Imported from inbound delivery
          <strong>{{ inboundDelivery.referenceNumber }}</strong>, received by
          <strong>{{ inboundDelivery.DeliveryPerson.name }}</strong>. Review quantities,
          select a vendor, enter costs, and save normally.
        </v-alert>
      </div>
      <div>
        <ProductSearchBar @submit="addRow" />
      </div>
      <div>
        <Cart />
      </div>
    </div>

    <v-dialog persistent v-model="noteDialog" width="500">
      <v-card class="note-dialog-card">
        <div class="dialog-header">
          <div>
            <div class="dialog-title">Purchase Note</div>
            <div class="dialog-subtitle">Add internal information for this purchase.</div>
          </div>
          <v-btn icon small @click="noteDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-4">
          <div class="field-label">Note</div>
          <v-textarea outlined dense auto-grow rows="4" v-model="purchaseNote" :label="$t('labels.note')" />
        </v-card-text>
        <v-divider />
        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn rounded depressed color="primary" dark @click="noteDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import purchaseService from "../service";
import vendorService from "@/modules/Inventory/Vendor/service.js";
import ProductSearchBar from "@/modules/Inventory/Purchase/components/ProductSearchBar";
import AutoComplete from "@/modules/Inventory/Vendor/components/AutoComplete";
import DateSelector from "@/components/DateSelector";
import inboundDeliveryService from "@/modules/Inventory/InboundDelivery/service";
// import productService from '@/modules/Product/service.js'
import Cart from "@/modules/Inventory/Purchase/components/Cart";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "create-purchase",
  data() {
    return {
      loading: false,
      selectedVendor: null,
      dialogCost: 0,
      editIndex: null,
      createDialog: false,
      noteDialog: false,
      initVendor: null,
      search: null,
      focusable: false,
      serialNumber: null,
      selectedProduct: null,
      products: [],
      inboundDelivery: null,
      inboundDeliveryId: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "productDetail",
          sortable: true,
        },
        {
          text: "Serial Number",
          align: "left",
          value: "serialNumber",
          sortable: true,
        },
        {
          text: "Quantity",
          align: "center",
          value: "qty",
          sortable: true,
        },
        {
          text: "Amount",
          align: "right",
          value: "rate",
          sortable: true,
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    selectedVendor(val) {
      this.SetVendor(val);
    },
  },
  components: {
    Cart,
    ProductSearchBar,
    AutoComplete,
    DateSelector,
  },
  async created() {
    document.title = "smplsale - New Purchase";
    if (this.$route.query && this.$route.query.InboundDeliveryId) {
      await this.loadInboundDelivery(this.$route.query.InboundDeliveryId);
    }
    if (this.$route.query && this.$route.query.VendorId) {
      const vendor = await vendorService.getById(this.$route.query.VendorId);
      this.initVendor = vendor.data;
    }
    const obj = this.$route.params;
    if (obj && Object.keys(obj).length !== 0) {
      // console.log('this.$router', this.$route.params)
      let list = obj;
      list.ImeiNumber.map((x) => {
        const row = {
          ProductId: list.Product.id,
          name: list.Product.name,
          imeiNumber: x,
          cost: list.Product.cost,
          total: list.Product.cost,
          qty: 1,
          Product: list.Product,
        };
        this.AddPurchaseDetail(row);
      });
    }
    this.SetPurchaseDate(this.$moment().toISOString());
  },
  computed: {
    ...mapGetters("purchase", [
      "PurchaseDetails",
      "Purchase",
      "purchaseTotal",
      "getImeiNumberDialog",
			"getPurchaseDate",
      "getPurchaseNote",
      "getPurchaseReferenceNumber"
    ]),
    ...mapGetters("global", ["currentBusiness"]),
    purchaseDate: {
      get: function () {
        return this.getPurchaseDate;
      },
      set: function (val) {
        this.SetPurchaseDate(val);
      },
    },
    purchaseNote: {
      get: function () {
        return this.getPurchaseNote;
      },
      set: function (val) {
        this.SetPurchaseNote(val);
      },
    },
    purchaseRefNumber: {
      get: function () {
        return this.getPurchaseReferenceNumber;
      },
      set: function (val) {
        this.SetPurchaseReferenceNumber(val);
      },
    },
  },
  methods: {
    ...mapActions("purchase", [
      "AddPurchaseDetail",
      "SetPurchaseDate",
      "SetVendor",
      "SetImeiNumberDialog",
      "SetSelectedProduct",
      "SetEditImeiNumberList",
      "ResetPurchase",
      "SetPurchaseNote",
      "SetPurchaseReferenceNumber"
    ]),
    async loadInboundDelivery(id) {
      this.loading = true;
      try {
        const response = await inboundDeliveryService.getById(id);
        const delivery = response.data;

        if (delivery.status === "converted" || delivery.PurchaseId) {
          this.$swal("Inbound Delivery", "This delivery has already been converted.", "warning");
          this.$router.replace(`/inventory/inboundDelivery/${delivery.id}/view`);
          return;
        }

        this.ResetPurchase();
        this.inboundDelivery = delivery;
        this.inboundDeliveryId = delivery.id;
        this.SetPurchaseReferenceNumber(delivery.referenceNumber || null);
        this.SetPurchaseNote(delivery.note || null);

        delivery.Details.forEach((detail) => {
          const product = detail.Product || {};
          const qty = Number(detail.quantity || 0);
          const cost = Number(product.cost || 0);
          this.AddPurchaseDetail({
            ProductId: detail.ProductId,
            name: detail.productName,
            cost,
            total: qty * cost,
            qty,
            boxQty: qty,
            unitCountInBox: detail.unitCountInBox || product.unitCountInBox,
            Product: product,
            InboundDeliveryDetailId: detail.id,
          });
        });
      } catch (error) {
        const message = error.data && error.data.message
          ? error.data.message
          : "Unable to import inbound delivery.";
        this.$swal("Inbound Delivery", message, "error");
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.ResetPurchase();
      this.$router.go(-1);
    },
    savePurchase() {
      if (!this.Purchase.VendorId) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Vendor is not selected!",
          });
      } else {
        if (this.currentBusiness.metadata && this.currentBusiness.metadata.lockPurchaseReferenceNumber && (!this.purchaseRefNumber || this.purchaseRefNumber.length < 4)) {
          this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Please enter reference number!",
          });
          return true
        }
        this.loading = true;
        if (!this.purchaseDate) {
          this.SetPurchaseDate(this.$moment().toISOString());
        }
        let newPurchase = {
          ...this.Purchase,
          InboundDeliveryId: this.inboundDeliveryId,
        };

        var filterPurchaseDetail = this.PurchaseDetails.filter(function (item) {
          if (!item.delete) {
            return item;
          }
        });

        // for (let index = 0; index < this.PurchaseDetails.length; index++) {
        //   const detail = this.PurchaseDetails[index];
        //   if (detail.delete) {
        //     this.PurchaseDetails.splice(index, 1)
        //   }
        // }
        //  // console.log('PurchaseDetails', this.PurchaseDetails)
        newPurchase.PurchaseDetails = filterPurchaseDetail;
        return purchaseService
          .create(newPurchase)
          .then(() => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
              })
              .fire({
                icon: "success",
                title: "Purchase created!",
              });
            // productService.resetCache()
            this.cancel();
            // this.ResetPurchase();
            // this.$router.push("/inventory/purchase/list");
          })
          .catch((error) => {
            // console.log("errorerror", error);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      }
    },
    addRow(val) {
      // console.log("in create add row", val);
      if (val.trackSerialNumber) {
        this.SetEditImeiNumberList({
          type: "new",
        });
        this.SetSelectedProduct(val);

        this.SetImeiNumberDialog(true);
      } else {
        this.AddPurchaseDetail({
          ProductId: val.id,
          name: val.Bar.name,
          cost: val.Bar.cost,
          total: val.Bar.total,
          qty: val.Bar.qty,
          boxQty: val.Bar.boxQty,
          unitCountInBox: val.unitCountInBox,
          Product: val,
        });
        // this.emptyEntryBar();
      }
    },
  },
};
</script>

<style scoped>
.purchase-create-page { background: #f8fafc; }
.purchase-create-card { border-radius: 20px; background: #fff; overflow: hidden; }
.purchase-create-header { padding: 16px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
.title-wrap { display: flex; align-items: center; }
.page-title { color: #0f172a; font-size: 22px; font-weight: 800; }
.dialog-subtitle { color: #64748b; font-size: 12px; margin-top: 2px; }
.header-actions { display: flex; align-items: center; gap: 8px; }
.field-label { color: #475569; font-size: 12px; font-weight: 700; margin-bottom: 6px; }
.note-column { display: flex; align-items: flex-end; padding-bottom: 6px; }
.purchase-create-content { display: grid; gap: 14px; margin-top: 14px; }
.note-dialog-card { border-radius: 20px; overflow: hidden; }
.dialog-header { padding: 18px 20px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.dialog-title { color: #0f172a; font-size: 20px; font-weight: 800; }
.dialog-actions { padding: 12px 16px; }
@media (max-width: 600px) {
  .purchase-create-header { padding: 14px; }
  .header-actions { width: 100%; }
  .header-actions .v-btn:last-child { flex: 1; }
}
</style>
